import { JsonObject, JsonProperty } from 'json-ts-mapper';

@JsonObject
export class Horaire {
  constructor (
    jour?: string,
    indexJour?: number,
    heureFermetureWeb?: string,
    heureOuvertureWeb?: string
  ) {
    this.jour = jour as any;
    this.indexJour = indexJour as any;
    this.heureFermetureWeb = heureFermetureWeb as any;
    this.heureOuvertureWeb = heureOuvertureWeb as any;
  }

  @JsonProperty(String)
  jour:string;

  @JsonProperty(Number)
  indexJour:number;

  @JsonProperty(String)
  heureFermetureWeb:string;

  @JsonProperty(String)
  heureOuvertureWeb:string;
}
